module.exports = __webpack_public_path__ + "static/img/profile.7703c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/profile.png
// module id = zhT1
// module chunks = 1